import { useAuiState } from '@assistant-ui/react';

import { MarkdownText } from '../markdown-text/MarkdownText.tsx';
import { Bubble } from '#plugin-chat/components/bubble/Bubble.tsx';
import type { BubbleKind } from '#plugin-chat/components/bubble/bubble-types.ts';
import { AskUserQuestionTool } from '#plugin-chat/components/tools/ask-user-question/AskUserQuestionTool.tsx';

export interface AssistantBubbleProps {
  /** Runtime status of the message, used to determine if streaming is active */
  status?: { type: string };
  /** Message content type (e.g., 'text', 'tool-call') */
  type?: string;
  /** The message text content */
  text?: string;
  /** Visual variant of the bubble */
  kind?: BubbleKind;
}

/** Renders an assistant message bubble with loading state for streaming responses. */
export function AssistantBubble({ status, text, kind }: AssistantBubbleProps) {
  const isRunning = status?.type === 'running';
  // Only show loader for text messages that are actively running but have no content yet
  const lastToolName = useAuiState((s) => {
    const lastPart = s.message.parts.at(-1);
    return lastPart?.type === 'tool-call' ? lastPart?.toolName : null;
  });

  if (isRunning && lastToolName === `${AskUserQuestionTool}`) {
    return null;
  }

  if (!isRunning && !text) {
    return null;
  }

  return (
    <Bubble corners={[]} kind={kind} role="assistant">
      <MarkdownText />
    </Bubble>
  );
}
